import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import endpoints from '../../../services/endpoints';
import TripCardSkeleton from '../../common/trip-card/trip-card-skeleton';
import { CustomText, WrapperContainer } from '@corporate-trip-planner-fe/ui-styles';
import { Destinations } from './destinations';
import { UpcomingTripsContent } from '../upcoming-trips/upcoming-trips.style';
import DestinationCard from '../../common/destination-card';
// Future => Data-driven, filter by season or region.
var TrendingTripDestinations = function (_a) {
    var _b = _a.destinations, destinations = _b === void 0 ? Destinations : _b, inProgress = _a.inProgress;
    var navigate = useNavigate();
    var handleViewAllTrips = function () {
        navigate('/view-all-trips');
    };
    var handleTripClick = function (event) {
        var _a;
        var tripId = (_a = event.target.closest("[data-trip-id]")) === null || _a === void 0 ? void 0 : _a.getAttribute("data-trip-id");
        if (tripId) {
            navigate("".concat(endpoints.web.tripDetails, "/").concat(tripId));
        }
    };
    return (_jsxs(WrapperContainer, { "$flexDirection": 'column', children: [_jsx(WrapperContainer, { "$justifyContent": 'space-between', "$responsive": false, "$padding": '0', children: _jsx(CustomText, { "$fontWeight": 'bold', children: "Trending Destinations" }) }), inProgress && _jsx(TripCardSkeleton, {}), destinations && _jsx(UpcomingTripsContent, { onClick: handleTripClick, children: destinations.map(function (destination) { return (_jsx(DestinationCard, { destination: destination }, destination.id)); }) })] }));
};
export default TrendingTripDestinations;
